import { applyMiddleware, createStore } from "redux";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk"; // corrected import
import { composeWithDevTools } from "redux-devtools-extension";

import pendingReducer from "../reducers/getPendingData";
import tabsReducer from "../reducers/tabs";
import queueReducer from "../reducers/getQueue";
import UserInformationReducer from "../reducers/userInformation";

const middleware = [thunk];

const Reducer = combineReducers({
  queue: queueReducer,
  pending: pendingReducer,
  userInfo: UserInformationReducer,
  tabs: tabsReducer,
});
const persistConfig = {
  key: "root",
  storage,
};
const persistedReducer = persistReducer(persistConfig, Reducer);
export const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);
export const persistor = persistStore(store);
